export default __webpack_public_path__ + "static/media/css.b1dc9eeb.png";